import React, { useEffect, useState } from "react";
import { Button, Form, Stack, Table } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { fetchProductsManagementData } from "../../../redux/slice/ProductManagementSlice";
import { fetchDistributorManagementData } from "../../../redux/slice/DistributionRegistrationSlice";
import { useFormik } from "formik";
import {
  registerBatchKit,
  startBatchKitCreation,
} from "../../../redux/slice/KitManagementSlice";
import { NavLink } from "react-router-dom";
import { fetchBatchKitsData } from "../../../redux/slice/BatchKits";
import ValidationSchema from "../../../components/Common/ValidationSchema";
import DropdownCalendar from "../../../components/Common/WheelDatepicker";
import "./index.css";
import { usePic } from "../../../context/PicProvider";
import moment from "moment";

const initialValues = {
  product_name: "",
  brand: "",
  kit_ref_id: "",
  product_code: "",
  lot_number: "",
  product_id: "",
  batch_number: "",
  kit_picture: "",
  van: "",
  expiry_date: null,
  distributor_id: "",
  quantity: "",
  formatedDate: "",
};
const CreateKit = () => {
  //Redux functions
  const { setIsLoading, setSuccessPopupBlue } = usePic();

  const ProductManagementData = useSelector((state) => state.PRODUCTMANAGEMENT);
  const { BatchKitsData } = useSelector((state) => state.BATCHKITS);
  const { deviceId } = useSelector((state) => state.AUTH);
  const dispatch = useDispatch();

  //React state
  const [place, setPlace] = useState(false);
  const [filteredProductNames, setFilteredProductNames] = useState(
    ProductManagementData?.ProductManagementData
  );
  const [productsData, setProductsData] = useState(
    BatchKitsData?.data?.relatedProducts.map((product) => ({
      ...product,
      item_not_expire: true,
    }))
  );
  const [showProd, setShowProd] = useState(false);
  const [parentProduct, setParentProduct] = useState({});
  const [maxKitExpiryDate, setMaxKitExpiryDate] = useState("");

  //Formik hook
  const {
    values,
    setValues,
    errors,
    handleBlur,
    handleChange,
    setFieldValue,
    touched,
    handleSubmit,
    resetForm,
  } = useFormik({
    enableReinitialize: true,
    initialValues: initialValues,
    validationSchema: ValidationSchema.createKit,
    // onSubmit: async (values, action) => {
    //   const res = await dispatch(registerBatchKit(values));
    //   if (res?.payload?.status === 200) {
    //     dispatch(setPdfData(res?.payload?.data));
    //     navigate("/kitpdf");
    //   }
    // },
  });
  //Lifecycle hooks
  useEffect(() => {
    setProductsData(BatchKitsData?.data?.relatedProducts);
  }, [BatchKitsData]);

  useEffect(() => {
    dispatch(fetchProductsManagementData());
    dispatch(fetchDistributorManagementData());
  }, []);

  useEffect(() => {
    if (values.product_code) {
      setShowProd(false);
      const filteredProducts =
        ProductManagementData?.ProductManagementData?.filter(
          (product) =>
            product.product_code &&
            typeof product.product_code === "string" && // Check if product_code is a string
            typeof values.product_code === "string" && // Check if values.product_code is a string
            product.product_code
              .toLowerCase()
              .includes(values.product_code.toLocaleLowerCase())
        );
      setFilteredProductNames(filteredProducts);
    } else {
      setFilteredProductNames([]);
      // Clear the product name field when product code is empty
      setValues({
        ...values,
        product_name: "",
      });
    }
  }, [values.product_code, ProductManagementData]);

  useEffect(() => {
    if (BatchKitsData?.data?.relatedProducts) {
      const currentDate = new Date().getTime();
      let minExpiryDate = null;
      const initialProducts = BatchKitsData.data.relatedProducts.map(
        (product) => ({
          ...product,
          item_not_expire: true, // Always set to true initially
        })
      );
      setProductsData(initialProducts);

      // Set default expiry date logic
      filteredProductNames.forEach((product) => {
        const expiryTime = new Date(product.expiry_date).getTime();
        if (!minExpiryDate || expiryTime < minExpiryDate) {
          if (expiryTime > currentDate) {
            minExpiryDate = expiryTime;
          }
        }
      });
      if (minExpiryDate) {
        const minExpiryDateObj = new Date(minExpiryDate);
        const formattedMinExpiryDate = minExpiryDateObj
          .toISOString()
          .split("T")[0];
        setValues({
          ...values,
          expiry_date: formattedMinExpiryDate,
        });
      }
    }
  }, [BatchKitsData]);

  //methods
  const handleToggleChange = (index) => {
    const updatedProducts = [...productsData];
    updatedProducts[index] = {
      ...updatedProducts[index],
      item_not_expire: !updatedProducts[index].item_not_expire,
      expiry_date: updatedProducts[index].item_not_expire
        ? ""
        : values.expiry_date,
    };
    setProductsData(updatedProducts);

    let minExpiryDate = Infinity;

    updatedProducts.forEach((product) => {
      if (!product.item_not_expire && product.expiry_date) {
        const expiryTime = new Date(product.expiry_date).getTime();
        if (expiryTime < minExpiryDate) {
          minExpiryDate = expiryTime;
        }
      }
    });

    // Update values.expiry_date if the minimum expiry_date is earlier
    if (minExpiryDate !== Infinity) {
      const minExpiryDateString = new Date(minExpiryDate)
        .toISOString()
        .slice(0, 10); // Convert minimum expiry_date to string
      setValues({
        ...values,
        expiry_date: minExpiryDateString,
      });
    } else {
      // No valid expiry_date found, clear values.expiry_date
      setValues({
        ...values,
        expiry_date: "",
      });
    }
  };

  const handleProductNameClick = async (element) => {
    setShowProd(true);
    setFieldValue("product_code", element.product_code);
    setFieldValue("product_name", element.product_name); // Set product name in values object
    setParentProduct(element);
    setFilteredProductNames([]);

    await dispatch(fetchBatchKitsData(element.kit_ref_id));
  };

  const onChangeToNumber = (value) => {
    if (typeof value === "number") return value;
    const numericValue = parseFloat(value);
    if (!isNaN(numericValue) && isFinite(numericValue)) {
      return numericValue;
    }
    return value;
  };

  const handleBatchCreate = async () => {
    if (Object.keys(errors).length > 0) {
      return;
    }

    const selectedProduct = {
      products: productsData,
      product_code: parentProduct.product_code,
      lot_number: values.lot_number,
      expiry_date: values.expiry_date,
      kit_ref_id: parentProduct.kit_ref_id,
      _id: parentProduct._id,
      brand: parentProduct.brand,
      kit_picture: parentProduct.kit_picture,
      product_name: parentProduct.product_name,
      quantity: values.quantity,
      model_number: parentProduct.model_number,
      deviceId: deviceId,
    };
    setIsLoading(true);
    try {
      const res = await dispatch(registerBatchKit(selectedProduct));
      setIsLoading(false);
      if (res?.payload?.status === 200) {
        dispatch(startBatchKitCreation(res?.payload?.data));
        setSuccessPopupBlue({
          open: true,
          primaryURL: "/kit",
          secondaryURL: "",
          message:
            "Your batch creation request has been received and is being processed. We'll send an email update once it's ready.",
          primaryText: "Ok, Got It!",
          secondaryText: "",
          title: "Batch Creation in Progress",
          child: null,
        });
        resetForm();
        setParentProduct({});
        setProductsData([]);
        setMaxKitExpiryDate("");
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  // Helper function to parse expiry_date
  const convertExpiryDate = (expiryDate) => {
    if (!expiryDate) return null;

    const [month, year] = expiryDate?.match(/[a-zA-Z]+|\d+/g);
    if (month && year) {
      const lastDate = new Date(
        year,
        new Date(Date.parse(`${month} 1, ${year}`)).getMonth() + 1,
        0
      );

      return lastDate.toISOString().split("T")[0];
    } else {
      return null;
    }
  };

  const onExpiryChange = (dateObj, index) => {
    const finalDate = dateObj.month + dateObj.year;
    const newDate = finalDate;
    const updatedProducts = [...productsData];
    updatedProducts[index] = {
      ...updatedProducts[index],
      expiry_date: newDate,
      item_not_expire: !newDate,
    };
    // Update productsData state with the modified product
    setProductsData(updatedProducts);
    // Final transformation
    const formattedArray = updatedProducts.map(({ expiry_date }) =>
      convertExpiryDate(expiry_date)
    );
    const filteredDates = formattedArray.filter((date) => date !== null);
    if (filteredDates.length > 0) {
      const minDate = moment.min(
        filteredDates.map((dateStr) => moment(dateStr))
      );
      const minFormattedDate = minDate.format("YYYY-MM-DD");
      setMaxKitExpiryDate(minFormattedDate);
      setValues({
        ...values,
        formatedDate: minFormattedDate,
        expiry_date: minFormattedDate,
      });
    } else {
      setMaxKitExpiryDate("");
      setValues({
        ...values,
        formatedDate: "",
        expiry_date: "",
      });
    }

    // Find the minimum expiry_date among all products that do expire
    let minExpiryDate = Infinity;

    updatedProducts.forEach((product) => {
      if (!product.item_not_expire && product.expiry_date) {
        const expiryTime = new Date(product.expiry_date).getTime();
        if (expiryTime < minExpiryDate) {
          minExpiryDate = expiryTime;
        }
      }
    });
    return;
  };

  const formatDate = (dateString) => {
    if (!dateString) return "";

    const date = new Date(dateString);
    const options = { month: "long", year: "numeric" };
    return date.toLocaleDateString("en-US", options);
  };

  const handleChangeProductQuantity = (e, index) => {
    let newValue = parseInt(e.target.value);
    // Prevent setting negative or zero values
    newValue = newValue > 0 ? newValue : "";
    const updatedProducts = [...productsData];
    updatedProducts[index] = {
      ...updatedProducts[index],
      lot_number: newValue,
    };
    setProductsData(updatedProducts);
  };

  const handleChangeExpiryDate = (dateObj, index) => {
    onExpiryChange(dateObj, index);
    // setFieldValue("formatedDate", "");
    // setFieldValue("expiry_date", "");
  };

  return (
    <Form
      onSubmit={handleSubmit}
      className="bg-white flex-grow-1 d-flex flex-column popup-layout"
    >
      <div
        className="position-sticky bg-white header-section"
        style={{ zIndex: 1 }}
      >
        <h4 className="text-center m-0 fw-bold">Batch Create Kits</h4>
        <hr className="my-3 my-md-4" />
        <h6 className="text-center my-4">Enter Product Details</h6>
        <div className="row">
          <div className="col-9">
            <div className="d-flex gap-3">
              <Form.Group className="mb-3" controlId="formBasicProduct">
                <Form.Control
                  type="text"
                  name="product_code"
                  className="cursor"
                  onChange={handleChange}
                  value={values.product_code}
                  placeholder="Product Code"
                  onBlur={handleBlur}
                  autoComplete="on"
                />
                {errors.product_code && touched.product_code && (
                  <p className="text-danger mt-1 mb-0">{errors.product_code}</p>
                )}
              </Form.Group>
              {values.product_code && (
                <Form.Group className="mb-3 col-9" controlId="formBasicProduct">
                  <Form.Control
                    type="text"
                    name="product_name"
                    value={values.product_name}
                    placeholder="Product Name"
                    readOnly
                  />
                  {errors.product_name && touched.product_name && (
                    <p className="text-danger mt-1 mb-0">
                      {errors.product_name}
                    </p>
                  )}
                </Form.Group>
              )}
            </div>
          </div>
          <div className="col-3">
            <Form.Group className="mb-3" controlId="formBasicLotNumber">
              <Form.Control
                type="text"
                name="lot_number"
                onChange={handleChange}
                value={values.lot_number}
                onBlur={handleBlur}
                placeholder="Lot Number"
              />
              {errors.lot_number && touched.lot_number && (
                <p className="text-danger mt-1 mb-0">{errors.lot_number}</p>
              )}
            </Form.Group>
          </div>
        </div>
      </div>
      <div className="row flex-grow-1">
        <div className="col-12 batch_table">
          <Table responsive>
            <thead></thead>
            <tbody>
              {showProd
                ? productsData &&
                  productsData?.map((curElm, index) => {
                    return (
                      <tr key={index}>
                        <td>
                          {curElm.product_code}-{curElm.product_name}
                        </td>
                        <td>
                          <Stack className="align-items-center">
                            <Form.Control
                              type="number"
                              value={curElm.quantity}
                              min="1"
                              onChange={(e) => {
                                let newValue = parseInt(e.target.value);
                                // Prevent setting negative or zero values
                                newValue = newValue > 0 ? newValue : 1;
                                const updatedProducts = [...productsData];
                                updatedProducts[index] = {
                                  ...updatedProducts[index],
                                  quantity: newValue,
                                };
                                setProductsData(updatedProducts);
                              }}
                              size="sm" // Set the size to small
                              style={{ width: "70px" }}
                            />
                          </Stack>
                        </td>
                        <td>
                          <Form.Control
                            className=""
                            type="text"
                            value={curElm.lot_number}
                            placeholder="Lot Number"
                            onChange={(e) =>
                              handleChangeProductQuantity(e, index)
                            }
                          />
                        </td>
                        <td style={{ verticalAlign: "middle" }}>
                          <Form.Check
                            type="switch"
                            id={`expiry-toggle-${index}`}
                            label=""
                            checked={curElm.item_not_expire}
                            onChange={() => handleToggleChange(index)}
                          />
                        </td>
                        <td>
                          {!curElm.item_not_expire ? (
                            // <YearMonthCalendar
                            <DropdownCalendar
                              value={curElm.expiry_date}
                              onDateChange={(date) =>
                                handleChangeExpiryDate(date, index)
                              }
                            />
                          ) : (
                            <span>Item doesn't expire</span>
                          )}
                          <Form.Control.Feedback type="invalid">
                            {errors.expiry_date}
                          </Form.Control.Feedback>
                        </td>
                      </tr>
                    );
                  })
                : filteredProductNames?.map((curElm, index) => (
                    <tr key={index} className="filtered_row">
                      <td onClick={() => handleProductNameClick(curElm)}>
                        {curElm.product_code}-{curElm.product_name}
                      </td>
                    </tr>
                  ))}
            </tbody>
          </Table>
        </div>
      </div>
      <div className="position-sticky bg-white footer-section">
        <div className="row row-gap-3 gx-3 mt-2 justify-content-end">
          <div className="col-sm-6 col-md-3">
            <Form.Group>
              <Form.Control
                onFocus={() => setPlace(true)}
                type={place ? "date" : "text"}
                name="expiry_date"
                placeholder="Kit Expiry Date"
                onChange={(e) => {
                  const { value } = e.target;
                  setFieldValue("expiry_date", value);
                  setPlace(false);
                  setFieldValue("formatedDate", value);
                }}
                value={
                  values.expiry_date ? formatDate(values.formatedDate) : ""
                }
                onBlur={() => {
                  setPlace(false);
                  handleBlur("expiry_date");
                }}
                {...(maxKitExpiryDate ? { max: maxKitExpiryDate } : {})}
                className="cursor text-center"
                style={{ backgroundColor: "#ddd" }}
              />
            </Form.Group>
            {errors.expiry_date && touched.expiry_date && (
              <p className="text-danger">{errors.expiry_date} </p>
            )}
          </div>
          <div className="col-sm-6 col-md-3">
            <Form.Group controlId="formBasicQuantity">
              <Form.Control
                type="text"
                name="quantity"
                onChange={handleChange}
                value={onChangeToNumber(values.quantity)}
                onBlur={handleBlur}
                placeholder="Batch Quantity"
              />
            </Form.Group>
            {errors.quantity && touched.quantity && (
              <p className="text-danger">{errors.quantity} </p>
            )}
          </div>
        </div>
        <hr />
        <div className="d-flex justify-content-end gap-3 flex-wrap-reverse">
          <NavLink to="/kit" className="btn btn-dark" type="button">
            Cancel
          </NavLink>
          <Button
            className="btn"
            type="submit"
            onClick={() => handleBatchCreate()} // Pass "pdf" type
          >
            Submit
          </Button>
        </div>
      </div>
    </Form>
  );
};

export default CreateKit;
